import { useEffect } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";

function Privacy() {
      useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
   <>  <div className="page-wrapper">
   <Header/>

        <div className="content-wrapper pt-50">
            <section className="terms">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

<div className="flex-1 lg:max-w-[1000px] lg:mx-auto lg:pt-24 pt-20 pb-12 lg:pb-16">
  <div className="lg:px-6 px-4">
    <div className="lg:mb-12 mb-8">
      <h1 className="lg:text-5xl text-3xl font-bold text-gray-900 lg:mb-6 mb-4">
        Privacy Policy
      </h1>
      <p className="text-gray-600 text-sm">Last Updated: January 2026</p>
    </div>
    <div className="prose prose-gray max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          1. Introduction
        </h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          This Privacy Policy explains how{" "}
          <strong>DIAL ERP TECHNOLOGIES LIMITED</strong> ("we", "us", "our")
          collects, uses, and protects personal information when you use
          LandPanda.com.
        </p>
        <p className="text-gray-700 leading-relaxed">
          By using the Platform, you consent to the practices described in this
          policy.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          2. Information We Collect
        </h2>
        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          2.1 Information You Provide
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3">We may collect:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Property or project details submitted in listings</li>
          <li>
            Any information you provide through contact forms or inquiries
          </li>
        </ul>
        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          2.2 Automatically Collected Information
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3">
          We may collect non-personal information such as:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device information</li>
          <li>Pages visited</li>
          <li>Cookies and similar tracking technologies</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          3. Use of Information
        </h2>
        <p className="text-gray-700 leading-relaxed mb-3">
          We use your information to:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li>Display property and project listings</li>
          <li>Respond to inquiries</li>
          <li>Improve platform functionality</li>
          <li>Ensure compliance with legal requirements</li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          We do not sell personal data to third parties.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          4. Data Sharing
        </h2>
        <p className="text-gray-700 leading-relaxed mb-3">
          We may share information with:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li>Service providers who assist in operating the Platform</li>
          <li>Government or legal authorities when required by law</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          5. Accuracy of Listings
        </h2>
        <p className="text-gray-700 leading-relaxed">
          We do not verify user-submitted data or public data retrieved from
          RERA or other sources. Users are responsible for verifying any
          information before acting upon it.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cookies</h2>
        <p className="text-gray-700 leading-relaxed">
          We use cookies to improve user experience. You may disable cookies
          through your browser settings, but some features of the Platform may
          not function properly.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          7. Data Security
        </h2>
        <p className="text-gray-700 leading-relaxed">
          We implement reasonable technical and organizational measures to
          protect your personal data. However, no system can guarantee complete
          security.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          8. Data Retention
        </h2>
        <p className="text-gray-700 leading-relaxed">
          We retain personal data only for as long as necessary to fulfill the
          purposes outlined in this policy or as required by law.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          9. User Rights (DPDP Act, 2023)
        </h2>
        <p className="text-gray-700 leading-relaxed mb-3">
          Under the Digital Personal Data Protection Act, 2023 (India), you have
          the right to:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent</li>
          <li>Raise grievances</li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          Requests can be sent to:{" "}
          <a
            href="mailto:info@landpanda.com"
            className="text-teal-600 hover:text-teal-700 font-medium"
          >
            info@landpanda.com
          </a>
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          10. Grievance Redressal
        </h2>
        <p className="text-gray-700 leading-relaxed mb-3">
          If you have concerns about how your data is handled, contact:
        </p>
        <div className="bg-teals rounded-lg p-6 border border-gray-200 mb-30">
          <p className="text-gray-900 font-semibold mb-2">Grievance Officer</p>
          <p className="text-gray-700 mb-1">DIAL ERP TECHNOLOGIES LIMITED</p>
          <p className="text-gray-700 mb-1">
            Email:{" "}
            <a
              href="mailto:info@landpanda.com"
              className="text-teal-600 hover:text-teal-700 font-medium"
            >
              info@landpanda.com
            </a>
          </p>
          <p className="text-gray-700">
            Mobile:{" "}
            <a
              href="tel:+917992799230"
              className="text-teal-600 hover:text-teal-700 font-medium"
            >
              +91 7992799230
            </a>
          </p>
        </div>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          11. Third-Party Websites
        </h2>
        <p className="text-gray-700 leading-relaxed">
          The Platform may contain links to external websites. We are not
          responsible for their privacy practices or content.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          12. Changes to Privacy Policy
        </h2>
        <p className="text-gray-700 leading-relaxed">
          We may update this Privacy Policy periodically. The updated version
          will be posted on this page with a revised "Last Updated" date.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          13. Contact Information
        </h2>
        <p className="text-gray-700 leading-relaxed mb-3">
          For privacy-related queries, contact:
        </p>
        <div className="bg-teals rounded-lg p-6 border border-teal-200 mb-70">
          <p className="text-gray-900 font-semibold mb-2">
            DIAL ERP TECHNOLOGIES LIMITED
          </p>
          <p className="text-gray-700 mb-1">
            Email:{" "}
            <a
              href="mailto:info@landpanda.com"
              className="text-teal-600 hover:text-teal-700 font-medium"
            >
              info@landpanda.com
            </a>
          </p>
          <p className="text-gray-700 mb-1">
            Mobile:{" "}
            <a
              href="tel:+917992799230"
              className="text-teal-600 hover:text-teal-700 font-medium"
            >
              +91 7992799230
            </a>
          </p>
          <p className="text-gray-700">
            Address: PADMA TOWER-2, 608, 6TH FLOOR, RAJENDRA PLACE, New Delhi,
            Delhi, India
          </p>
        </div>
      </section>
    </div>
   
  </div>
</div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
   <Footer/>
   </div>
   </>
  );
}

export default Privacy;